<template>
  <div class="consent-page" v-loading.fullscreen.lock="loading">
    <el-row>
      <el-col v-if="consent">
        <div class="page-header">
          <h1 class="h1 page-title">{{ consent.heading }}</h1>
          <h2 class="h2 page-subtitle">{{ consent.header }}</h2>
        </div>
      </el-col>

      <el-col v-if="consent">
        <div class="consent-text">
        <span v-html="consent.content"></span>
        </div>
      </el-col>

      <el-col>
        <user-vehicle-form />
      </el-col>

      <el-col class="radio-box">
        <el-radio v-model="isAgree" :label="true" border>I agree</el-radio>
        <el-radio v-model="isAgree" :label="false" class="radio__danger" border>I decline</el-radio>
        <span v-if="consent" id="terms" v-html="consent.terms_condition" class="italic"></span>
      </el-col>

      <el-col>
        <div class="page-controls">
          <el-button type="primary" @click="$router.go(-1)" icon="el-icon-arrow-left" :disabled="loading">Back</el-button>
          <el-button type="primary" :loading="loading" :disabled="isAgree === null || loading" @click="submit">Continue</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import CheckCode from '../mixins/check-code'
import BuildingConsentService from '../services/building-consent-service'
import ComputedStorage from '../mixins/computed-storage'
import UserVehicleForm from '../components/user-vehicle-form'

export default {
  mixins: [CheckCode, ComputedStorage],
  components: {UserVehicleForm},
  data () {
    return {
      loading: true,
      isAgree: null,
      consentArr: [],
      code: null,
      consent: null
    }
  },

  watch: {
    code(newVal, oldVal) {
      if (oldVal !== null)
        return;

      BuildingConsentService.getConsent(this.code.building.id, this.invitationCode).then(response => {
        this.consent = response.data
        this.loading = false
      }).catch(error => {
        throw new Error('Error in "BuildingConsentService": ', error)
      })
    },

    isAgree(iAgreeNow) {
      let terms = document.getElementById("terms")
      if (iAgreeNow) {
        terms.classList.remove("declined");
      } else {
        terms.classList.add("declined");
      }
    }
  },

  filters: {
    striphtml(value) {
      let div = document.createElement("div");
      div.innerHTML = value;
      let text = div.textContent || div.innerText || "";

      return text;
    }
  },

  methods: {
    submit() {
      this.loading = true

      if (this.consentUrl){
        this.$router.push({name: 'GuestRegistrationThanks'})
        return true
      }

      const data = this.createValidData()

      BuildingConsentService.agree(data).then(response => {
        if (!response.data.created){
          this.loading = false
          throw new Error('Error in "BuildingConsentService"')
        }

        this.$store.commit('registration/setConsent', {heading: this.consent.heading, url: response.data.resource.link})
        this.$router.push({name: 'GuestRegistrationThanks'})
      }).catch(error => {
        this.loading = false
        throw new Error('Error in "BuildingConsentService": ', error);
      })
    },

    createValidData() {
      return {
        code: this.invitationCode,
        guest_id: this.guestId,
        vehicle_id: this.vehicleData.id,
        agreement: this.isAgree ? 1 : 0,
      }
    }
  },

  created() {
    this.checkInviteCode(code => {
      this.code = code
    });
  }
}
</script>


<style lang="scss" scoped>
p {
  text-indent: 24px;
}
.consent-text p {
  text-align: justify;
  line-height: 20px;
}
.radio-box {
  margin-bottom: 24px;
}
@media screen and (max-width: 768px) {
  .page-controls {
    display: flex;
    justify-content: space-around;
  }
}
</style>

<style>
.declined {
  color: #F56C6C !important;
}
.el-radio.is-bordered.radio__danger.is-checked {
  border-color: #F56C6C;
}
.el-radio.radio__danger.is-checked .el-radio__input.is-checked .el-radio__inner {
  border-color: #F56C6C;
  background: #F56C6C;
}
.el-radio.radio__danger.is-checked .el-radio__input.is-checked + .el-radio__label {
  color: #F56C6C;
}
.italic {
  font-style: italic;
}
</style>
